module.exports = __webpack_public_path__ + "static/background_mobile-e935869b987df569bb076d6bf6f4e09c.svg";